import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { ContentComponent } from "./shared/components/layout/content/content.component";
import { FullComponent } from "./shared/components/layout/full/full.component";
import { full } from "./shared/routes/full.routes";
import { content } from "./shared/routes/routes";

import { AdminGuard } from './shared/guard/admin.guard';
import { LoginImageTwoComponent } from './auth/image-two/image-two.component';
import { loginGuard } from './shared/guard/login.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'auth/login',
    component: LoginImageTwoComponent,
    canActivate: [loginGuard]
  },
  {
    path: '',
    component: ContentComponent,
    canActivate: [AdminGuard],
    children: [...content]
  },
  // {
  //   path: '',
  //   component: FullComponent,
  //   canActivate: [AdminGuard],
  //   children: [...full]
  // },
  // {
  //   path: 'unauthorized',
  //   loadChildren: () => import('./../app/pages/unauthorized/unauthorized.module').then(m => m.UnauthorizedModule)
  // },
  {
    path: '**',
    redirectTo: 'error-page',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [[RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled',
  })],
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }